import { CreateForm } from "./CreateForm";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AdminBannerService } from "../service";
import {IBanner} from "../interface";

export const CreateBanner = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [state, setState] = useState<IBanner | null>(null);
    const [image, setImage] = useState<File | null>(null);
    const [zones, setZones] = useState<any[]>();

    const submitHandler = () => {
        const formData = new FormData();
        formData.append('body', JSON.stringify(state))
        image && formData.append("image", image);
        AdminBannerService.create(formData)
            .then(() => {
                SuccessToast(t(`banner.successfully_created`));
                navigate("/admin/banner");
                setTriggerUpdate(!triggerUpdate);
                setState(null);
            })
            .catch(ErrorToast);
    };
  useEffect(() => {
    AdminBannerService.getAllZone({
      page: 0,
      perPage: 0,
    })
      .then((response) => {
        const { data } = response;
        setZones(data?.items);
        window.scrollTo(0, 0);
      })
      .catch(ErrorToast);
  }, []);
  return (
    <div className="col-12">
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          submitHandler();
        }}
      >
        <CreateForm state={state} setState={setState} setImage={setImage} zones={zones} />
      </Form>
    </div>
  );
};
